module.exports = __webpack_public_path__ + "static/media/history.50ce6290.svg";